<div data-testid="delete-alert-dialog-confirmpopup" class="confirmpopup">
    <div data-testid="-delete-alert-dialog-dialog-title" mat-dialog-title>
      <label data-testid="delete-alert-dialog-title-label" class="title">Delete Alert:</label>
    </div>
    <hr data-testid="delete-alert-dialog-first-hr">
    <div data-testid="delete-alert-dialog-dialog-content" mat-dialog-content>
      <p data-testid="delete-alert-dialog-content-p">Are you sure you want to delete this alert?</p>
      <p data-testid="delete-alert-dialog-content-p2">{{alertData.alertName}}</p>
    </div>
    <hr data-testid="delete-alert-dialog-second-hr">
    <div data-testid="delete-alert-dialog-dialog-actions" mat-dialog-actions style="float: right;">
      <button
        data-testid="delete-alert-dialog-ok-button"
        type="submit" mat-raised-button
        (click)="okClick()"
        color="primary"
        cdkFocusInitial matTooltip="Delete alert"
        aria-label="Delete Alert"
        [disabled]="isLoading"
        >
        @if(isLoading){
          <mat-spinner
            data-testid="delete-gl-dialog-spinner"
            color="accent"
            diameter="30">
          </mat-spinner>
        } @else {
          <span data-testid="delete-alert-dialog-ok-span">Ok</span>
        }
      </button>
      <button
        data-testid="delete-alert-dialog-no-button"
        mat-raised-button
        (click)="onNoClick()"
        color="warn"
        [disabled]="isLoading">
          No
      </button>
    </div>
  </div>
  